
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
} from '@angular/forms';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { CommonService } from 'src/app/middleware/common/common.service';
import * as jwt_decode from 'jwt-decode';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { AddFieldsVM } from 'src/app/viewModels/core/add-fields-vm';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription } from 'rxjs';
import { SettingService } from '../../settings/services/settingService/setting.service';
import { ModuleName } from '../services/form.enum';

@Component({
  selector: 'app-create-fillable-fields',
  templateUrl: './create-fillable-fields.component.html',
  styleUrls: ['./create-fillable-fields.component.scss'],
})
export class CreateFillableFieldsComponent implements OnInit {
  folderList: any;
  folderName: any;
  OfficeIDList: any = [];
  myOfficeID: any;

  constructor(private formBuilder: FormBuilder, private constant: Constants, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private statusConst: StatusConstant, private loaderService: LoaderService,
    private toastr: ToastrService, private router: Router,private settingsService: SettingService,
    private commonService: CommonService, private addFieldsVM: AddFieldsVM,private _dataSharingService: DataSharingService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);   
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
    this.folderDetail = this.commonService.getEditData();
    if (this.folderDetail != undefined) {
      this.folderId = this.folderDetail.folderID;
    }
    this.fieldType = this.commonService.getFieldType();

    this.fieldData = this.commonService.getFieldData();

    if (this.fieldData != undefined) {
    }    
  }
  addCreatefieldForm: FormGroup;

  getAllfolderList = {
    folderID: 0,
    userID: '',
    databaseID: 0,
    organizationID: 0,
    officeID:0,
    OfficeIDList:[]
  };

  folderIdCheckbox: any[] = [];
  getAllSubfolderListResponseHolder: any;

  selectedFolders = {
    folderID: 0,
    subFolderID: 0,
    position: 0,
    viewOrder: 0,
  };

  showFieldVategoryTypeGlobal: boolean = true;
  showFieldVategoryTypecustom: boolean = false;
  coreList: any;
  taskList: any;
  companyList: any;
  contactList: any;
  coreValue: any[] = [];
  taskValue: any[] = [];
  companyValue: any[] = [];
  contactValue: any[] = [];
  dropdownValue: any[] = [];

  addCreadField = {
    userID: 'string',
    databaseID: 0,
    fieldName: 'string',
    fieldTypeID: 0,
    position: 0,
    defaultValue: 'string',
    placeholder: '',
    fieldCategotyTypeID: 0,
    organizationID: 0,
    officeID:0,
    OfficeIDList:[],
    AvailableOn:1,
    selectedFolders: [
      {
        folderID: 0,
        subFolderID: 0,
        position: 0,
        viewOrder: 0,
      },
    ],
    fieldNames: null,
  };

  folderIdCheck: boolean = false;
  dropDownPlace: string = '';
  fieldType: any;
  fieldData: any;
  EditField: boolean = false;
  addFieldResponseHolder: any;
  folderDetail: any;
  folderId: any;
  closeSlideValue: boolean = false;
  currentUser: any;
  getFieldTypeListResponseHolder: any;
  getFieldsListResponseHolder: any;
  fieldTypeList: any[] = [];
  fieldTypeReqModel = {
    userID: '',
    databaseID: 0,
    pageIndex: 1,
    pageSize: 10,
    officeID:0,
    OfficeIDList:[]
  };
  getFieldModel = {
    userID: '',
    databaseID: 0,
    organizationID: 0,
    officeID: 0,
    OfficeIDList:[]
  };
  fieldsList: any[] = [];
  fieldListFolderWise: any[] = [];
  checkBoxFieldArray: Array<any> = [];
  checkBoxFieldAttribute: any = {
    Select: false,
  };

  inputTypeFieldArray: Array<any> = [];
  inputTypeFieldAttribute: any = {
    fieldText: '',
    placeholder: '',
  };

  imageTypeFieldArray: Array<any> = [];
  imageTypeFieldAttribute: any = {
    altText: '',
  };

  dropdownFieldArray: Array<any> = [];
  dropdownFieldAttribute: any = {
    dropdownText: '',
  };

  urlTypeFieldArray: Array<any> = [];
  urlTypeFieldAttribute: any = {
    url: '',
  };

  numberTypeFieldArray: Array<any> = [];
  numberTypeFieldAttribute: any = {
    number: '',
  };

  dateTypeFieldArray: Array<any> = [];
  dateTypeFieldAttribute: any = {
    dateKey: '',
  };

  radioFieldArray: Array<any> = [];
  radioFieldAttribute: any = {
    radioText: '',
  };

  showRadioField: boolean = false;
  showDateField: boolean = false;
  showCurrencyField: boolean = false;
  showNumberField: boolean = false;
  showTextBoxField: boolean = false;
  showImageField: boolean = false;
  showDropdownBoxField: boolean = false;
  showCheckboxField: boolean = false;
  showUrlField: boolean = false;
  selectedItems: any;
  typeSelected: any;
  dropdownFieldOptionArray: any[] = [];
  dropdownFieldOptionAttribute = {
    dropdownId: 0,
    dropdownOptionName: '',
  };
  fieldLabel: any;
  position: any;
  clickEventsubscription: Subscription;
  @Output() closeSlide = new EventEmitter<boolean>();
  
  ngOnInit(): void {
    this.addCreatefieldForm = this.formBuilder.group({
      fieldCategoty: ['2', Validators.required],
      fieldTypeID: ['', Validators.required],
      fieldName: ['', Validators.required],
      checkArray: this.formBuilder.array([], []),
      urlPlaceholder: [''],
      textboxPlaceholder: [''],
      numberPlaceholder: [''],
      currencyPlaceholder: [''],
      datePlaceholder: [''],
      dropPlaceholder: [''],
      availableonForms: ['', Validators.required]      
    });
    this.getFieldTypeDropdown();
    this.getAllFields();
    this.getAllFolder();       

    this.clickEventsubscription = this._dataSharingService.getSelectedFolderIdInSetting().subscribe((result) => {
        if (result != '' && result != undefined) {
          this.folderIdCheckbox = [];
          this.folderIdCheckbox.push(result);
          const checkArray: FormArray = this.addCreatefieldForm.get('checkArray') as FormArray;
          checkArray.push(new FormControl(result));
          this.folderIdCheck = true;
          this.folderId = result;
          this.addCreatefieldForm.get('availableonForms').setValue("2");
        }
      });   
  }



  closecreateField(message: boolean) {
    this.addCreatefieldForm.reset();
    this.addCreatefieldForm.controls['fieldCategoty'].setValue('2');
    this.showFieldVategoryTypeGlobal = true;
    this.showFieldVategoryTypecustom = false;
    this.clear();
    this.folderIdCheck = true;
    this.closeSlide.emit(message);
  }

  onCheckboxChange(e) {
    const checkArray: FormArray = this.addCreatefieldForm.get('checkArray') as FormArray;
    if (e.checked) {
      let a = e.source.value;
      checkArray.push(new FormControl(e.source.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: FormControl) => {
        if (item.value == e.source.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }

    if (checkArray.length != 0) {
      this.folderIdCheck = true;
    } else {
      this.folderIdCheck = false;
    }
  }

  onRadiobuttonChange(e) {
    if (e.source.value == '2') {
      this.showFieldVategoryTypeGlobal = true;
      this.showFieldVategoryTypecustom = false;
      this.folderIdCheck = false;
    } else {
      this.showFieldVategoryTypecustom = true;
      this.showFieldVategoryTypeGlobal = false;
      this.folderIdCheck = false;
    }
    this.addCreatefieldForm.controls['fieldTypeID'].setValue('');
    this.clear();
  }

  addFieldValue(formValues) {
    if (formValues != undefined) {
      this.loaderService.show();
      this.addCreadField.userID = this.currentUser.UID;
      this.addCreadField.databaseID = parseInt(sessionStorage.getItem('databaseId'));
      this.addCreadField.fieldName = formValues.fieldName;
      this.addCreadField.fieldTypeID = formValues.fieldTypeID;
      this.addCreadField.position = 1;
      this.addCreadField.defaultValue = '';
      this.addCreadField.fieldCategotyTypeID = Number(formValues.fieldCategoty);
      this.addCreadField.organizationID = Number(sessionStorage.getItem('organizationID'));
      this.addCreadField.officeID = this.myOfficeID;
      this.addCreadField.OfficeIDList = this.OfficeIDList;
       this.addCreadField.AvailableOn = Number(2);// Number(formValues.availableonForms);
      let tempArray = [];
      let post = 1;
      if (this.addCreadField.fieldCategotyTypeID == 3) {
        this.getAllSubfolderListResponseHolder.data.forEach((element) => {
          if (element.folderName == ModuleName.Company && this.companyValue != null) {
            if (this.companyValue.length > 0) {
              let count = 0;
              let postcount = 1;
              for (let i of this.companyValue) {
                let copyModel = Object.assign({}, this.selectedFolders);
                copyModel.folderID = element.folderID;
                copyModel.subFolderID = i;
                this.fieldsList.forEach((element1) => {
                  if (element1.folderID == copyModel.folderID) {
                    if (postcount == 1) {
                      count = 1;//element1.fieldData.length + 1; not in use
                      postcount = postcount + 1;
                    }
                    copyModel.position = count;
                    copyModel.viewOrder = count;
                    if (post == 1) {
                      this.addCreadField.position = copyModel.position;
                    }
                    post = post + 1;
                  }
                });
                count = count + 1;
                tempArray.push(copyModel);
              }
            }
          } else if (element.folderName == ModuleName.Contact && this.contactValue != null) {
            if (this.contactValue.length > 0) {
              let count = 0;
              let postcount = 1;
              for (let i of this.contactValue) {
                let copyModel = Object.assign({}, this.selectedFolders);
                copyModel.folderID = element.folderID;
                copyModel.subFolderID = i;
                this.fieldsList.forEach((element1) => {
                  if (element1.folderID == copyModel.folderID) {
                    if (postcount == 1) {
                      count = 1;//element1.fieldData.length + 1; not in use
                      postcount = postcount + 1;
                    }
                    copyModel.position = count;
                    copyModel.viewOrder = count;
                    if (post == 1) {
                      this.addCreadField.position = copyModel.position;
                    }
                    post = post + 1;
                  }
                });
                count = count + 1;
                tempArray.push(copyModel);
              }
            }
          } else if (element.folderName == ModuleName.Core && this.coreValue != null) {
            if (this.coreValue.length > 0) {
              let count = 0;
              let postcount = 1;
              for (let i of this.coreValue) {
                let copyModel = Object.assign({}, this.selectedFolders);
                copyModel.folderID = element.folderID;
                copyModel.subFolderID = i;
                this.fieldsList.forEach((element1) => {
                  if (element1.folderID == copyModel.folderID) {
                    if (postcount == 1) {
                      count = 1;//element1.fieldData.length + 1; not in use
                      postcount = postcount + 1;
                    }
                    copyModel.position = count;
                    copyModel.viewOrder = count;
                    if (post == 1) {
                      this.addCreadField.position = copyModel.position;
                    }
                    post = post + 1;
                  }
                });
                count = count + 1;
                tempArray.push(copyModel);
              }
            }
          } else if (element.folderName == ModuleName.Task && this.taskValue != null) {
            if (this.taskValue.length > 0) {
              let count = 0;
              let postcount = 1;
              for (let i of this.taskValue) {
                let copyModel = Object.assign({}, this.selectedFolders);
                copyModel.folderID = element.folderID;
                copyModel.subFolderID = i;
                this.fieldsList.forEach((element1) => {
                  if (element1.folderID == copyModel.folderID) {
                    if (postcount == 1) {
                      count = 1;//element1.fieldData.length + 1; not in use
                      postcount = postcount + 1;
                    }
                    copyModel.position = count;
                    copyModel.viewOrder = count;
                    if (post == 1) {
                      this.addCreadField.position = copyModel.position;
                    }
                    post = post + 1;
                  }
                });
                count = count + 1;
                tempArray.push(copyModel);
              }
            }
          }
        });

        this.addCreadField.selectedFolders = tempArray;
      } else {
        formValues.checkArray.forEach((element) => {
          let copyModel = Object.assign({}, this.selectedFolders);
          copyModel.folderID = element;

          this.fieldsList.forEach((element1) => {
            if (element1.folderID == copyModel.folderID) {
              let   count = 1;//element1.fieldData.length + 1; not in use
              copyModel.position = count;
              copyModel.viewOrder = count;
              if (post == 1) {
                this.addCreadField.position = copyModel.position;
              }
              post = post + 1;
            }
          });
          tempArray.push(copyModel);
        });

        if (tempArray.length == 0 || tempArray == undefined) {
          let copyModel = Object.assign({}, this.selectedFolders);
          copyModel.folderID = this.folderId; //17;

          this.fieldsList.forEach((element1) => {
            if (element1.folderID == copyModel.folderID) {
              let   count = 1;//element1.fieldData.length + 1; not in use
              copyModel.position = count;
              copyModel.viewOrder = count;
              if (post == 1) {
                this.addCreadField.position = copyModel.position;
              }
              post = post + 1;
            }
          });
          tempArray.push(copyModel);
        }
        this.addCreadField.selectedFolders = tempArray;
      }

      if (this.showDropdownBoxField == true) {
        this.dropdownFieldArray.forEach((element) => {
          this.addCreadField.defaultValue += element.dropdownText + ',';
          this.addCreadField.placeholder = this.dropDownPlace;
        });
      } else if (this.showCheckboxField == true) {
        this.checkBoxFieldArray.forEach((element) => {
          this.addCreadField.defaultValue += element.Select + ',';
          this.addCreadField.placeholder = '';
        });
      } else if (this.showTextBoxField == true) {
        this.inputTypeFieldArray.forEach((element) => {
          this.addCreadField.defaultValue += element.fieldText;
          this.addCreadField.placeholder = element.placeholder;
        });
      } else if (this.showImageField == true) {
        this.imageTypeFieldArray.forEach((element) => {
          this.addCreadField.defaultValue += element.altText;
        });
      } else if (this.showUrlField == true) {
        this.urlTypeFieldArray.forEach((element) => {
          this.addCreadField.placeholder += element.url;
          this.addCreadField.defaultValue = '';
        });
      } else if (
        this.showNumberField == true ||
        this.showCurrencyField == true
      ) {
        this.numberTypeFieldArray.forEach((element) => {
          this.addCreadField.placeholder += element.number;
          this.addCreadField.defaultValue = '';
        });
      } else if (this.showRadioField == true) {
        this.radioFieldArray.forEach((element) => {
          this.addCreadField.defaultValue += element.radioText + ',';
          this.addCreadField.placeholder = '';
        });
      } else if (this.showDateField == true) {
        this.dateTypeFieldArray.forEach((element) => {
          this.addCreadField.placeholder += element.dateKey;
          this.addCreadField.defaultValue = '';
        });
      }

      this.settingsService.addField(this.addCreadField).subscribe((response) => {
          if (response) {
            this.addFieldResponseHolder = response;
            this.loaderService.hide();
            if (this.addFieldResponseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Field created successfully.', '', {
                timeOut: 3000,
              });
            } else {
              this.toastr.error(this.addFieldResponseHolder.message, '', {
                timeOut: 3000,
              });
            }
            this.addCreatefieldForm.reset();
            this.clear();
            this.showFieldVategoryTypeGlobal = true;
            this.showFieldVategoryTypecustom = false;
            this.addCreatefieldForm.controls['fieldCategoty'].setValue('2');
            let closePanel = false;
            this.closecreateField(closePanel);
            this._dataSharingService.sendClickEventforfieldsForms();            
          }
        });
    }
  }

  getFieldTypeDropdown() {
    this.fieldTypeReqModel.userID = this.currentUser.UID;
    this.fieldTypeReqModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.fieldTypeReqModel.pageSize = 20;
	  this.fieldTypeReqModel.officeID = this.myOfficeID;
    this.fieldTypeReqModel.OfficeIDList = this.OfficeIDList;
    this.settingsService.getFieldTypeList(this.fieldTypeReqModel).subscribe((response) => {
        if (response != undefined) {
          this.getFieldTypeListResponseHolder = response;
          if (this.getFieldTypeListResponseHolder.status ==this.statusConst.statusSuccess) {
            this.fieldTypeList = this.getFieldTypeListResponseHolder.data;
            this.fieldTypeList = this.fieldTypeList.filter((e) => e.fieldTypeName != 'Image');
          } else {            
          }
        }
      });
  }

  getAllFolder() {
    this.getAllfolderList.userID = this.currentUser.UID;
    this.getAllfolderList.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getAllfolderList.folderID = 0;
    this.getAllfolderList.organizationID = Number(sessionStorage.getItem('organizationID'));
    this.getAllfolderList.officeID = this.myOfficeID;
    this.getAllfolderList.OfficeIDList = this.OfficeIDList;
    this.settingsService.getAllFolderlist(this.getAllfolderList).subscribe((response) => {
        if (response != undefined) {
          this.getAllSubfolderListResponseHolder = response;
          if (this.getAllSubfolderListResponseHolder.status ==this.statusConst.statusSuccess) {
            this.getAllSubfolderListResponseHolder.data.forEach((element) => {
              if (element.folderName == ModuleName.Company) {
                this.companyList = element.subFolders;
              } else if (element.folderName == ModuleName.Contact) {
                this.contactList = element.subFolders;
              } else if (element.folderName == ModuleName.Core) {
                this.coreList = element.subFolders;
              } else if (element.folderName == ModuleName.Task) {
                this.taskList = element.subFolders;
              }
            });
          } else {
           
          }
        }
      });
  }

  displayCoreTypeSelection(e) {
    this.coreValue = e.value;
    if (
      this.taskValue.length == 0 &&
      this.coreValue.length == 0 &&
      this.contactValue.length == 0 &&
      this.companyValue.length == 0
    ) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  displayTaskTypeSelection(e) {
    this.taskValue = e.value;
    if (
      this.taskValue.length == 0 &&
      this.coreValue.length == 0 &&
      this.contactValue.length == 0 &&
      this.companyValue.length == 0
    ) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  displayCompanyTypeSelection(e) {
    this.companyValue = e.value;
    if (
      this.taskValue.length == 0 &&
      this.coreValue.length == 0 &&
      this.contactValue.length == 0 &&
      this.companyValue.length == 0
    ) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  displayContactTypeSelection(e) {
    this.contactValue = e.value;
    if (
      this.taskValue.length == 0 &&
      this.coreValue.length == 0 &&
      this.contactValue.length == 0 &&
      this.companyValue.length == 0
    ) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  clear() {
    const checkArray: FormArray = this.addCreatefieldForm.get('checkArray') as FormArray;
    checkArray.clear();
    this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
    this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
    this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
    this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
    this.addCreatefieldForm.get('datePlaceholder').clearValidators();
    this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
    this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
    this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
    this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
    this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
    this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
    this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
    this.showCheckboxField = false;
    this.showDropdownBoxField = false;
    this.showTextBoxField = false;
    this.showImageField = false;
    this.showUrlField = false;
    this.showNumberField = false;
    this.showCurrencyField = false;
    this.showRadioField = false;
    this.showDateField = false;
    this.inputTypeFieldArray = [];
    this.checkBoxFieldArray = [];
    this.dropdownFieldArray = [];
    this.imageTypeFieldArray = [];
    this.urlTypeFieldArray = [];
    this.numberTypeFieldArray = [];
    this.dateTypeFieldArray = [];
    this.radioFieldArray = [];
   // this.getAllFolder();
    // this.getAllFields();
    this.taskValue = [];
    this.coreValue = [];
    this.contactValue = [];
    this.companyValue = [];
  }

  CompanyName:string="";
  CoreName:string="";
  ContactName:string="";

  getAllFields() { 
    this.getFieldModel.userID = this.currentUser.UID;
    this.getFieldModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getFieldModel.organizationID = parseInt(sessionStorage.getItem('organizationID'));
    this.getFieldModel.officeID = this.myOfficeID;
    this.getFieldModel.OfficeIDList = this.OfficeIDList;
    this.settingsService.getAllFolderlist(this.getFieldModel).subscribe((response) => {
        if (response != undefined) {
          this.getFieldsListResponseHolder = response;
          if(this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
            this.fieldsList = this.getFieldsListResponseHolder.data.filter((m) => m.folderName !=  ModuleName.Task && m.folderName != ModuleName.Forms);
            var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
            var coreName=[];
            coreName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core); 
            if(coreName.length>0){
              this.CoreName= coreName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == ModuleName.Core).folderName = this.CoreName;
            }
           
            var contName =[];
            contName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
            if(contName.length>0){
              this.ContactName = contName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == ModuleName.Contact).folderName = this.ContactName;
            }
            
            var compName =[];
            compName= menuModulesList.filter(x => x.mainModuleName == ModuleName.Company);
            if(compName.length>0){
              this.CompanyName = compName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == ModuleName.Company).folderName = this.CompanyName;
            }         
            this.fieldsList.forEach((element) => {
              if (element.folderID == this.folderId) {
                this.fieldListFolderWise = element.fieldData;          
              }
            });
          } else {
           
          }
        }
      });
  }

  addValueField() {
    this.checkBoxFieldAttribute = null;
    let tempObject = Object.assign({}, this.checkBoxFieldAttribute);
    this.checkBoxFieldArray.push(tempObject);
  }

  addValueFieldRadio() {
    let tempObject = Object.assign({}, this.radioFieldAttribute);
    this.radioFieldArray.push(tempObject);
  }

  addValueFieldropdown() {   
    this.dropdownFieldAttribute = null;
    let tempObject = Object.assign({}, this.dropdownFieldAttribute);
    this.dropdownFieldArray.push(tempObject);
  }

  TextName:string="";
  TextIcon:string="";

  displayFieldOnFieldTypeSelection(event) {
    var getdata = this.fieldTypeList.filter((s) => s.fieldTypeID == event.value);
    if(getdata.length > 0){
      this.TextName= getdata[0].fieldTypeName;
      this.TextIcon= getdata[0].icon;
    }
    if (event != undefined) {
      let fieldTypeName = '';
      this.fieldTypeList.forEach((element) => {
        if (element.fieldTypeID == event.value) {
          if(element.fieldTypeName == this.constant.TextArea ||  element.fieldTypeName == this.constant.TextBox) {
            this.showTextBoxField = true;
            this.showDropdownBoxField = false;
            this.showCheckboxField = false;
            this.showImageField = false;
            this.showCurrencyField = false;
            this.showNumberField = false;
            this.showUrlField = false;
            this.showRadioField = false;
            this.showDateField = false;
            this.inputTypeFieldArray = [];
            this.inputTypeFieldArray.push(this.inputTypeFieldAttribute);
            this.checkBoxFieldArray = [];
            this.dropdownFieldArray = [];
            this.imageTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('textboxPlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (
            element.fieldTypeName == this.constant.DropDownField ||
            element.fieldTypeName == this.constant.MultiSelect
          ) {
            this.showDropdownBoxField = true;
            this.showTextBoxField = false;
            this.showCheckboxField = false;
            this.showImageField = false;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showNumberField = false;
            this.showUrlField = false;
            this.dropDownPlace = '';
            this.dropdownFieldArray = [];
            this.dropdownFieldArray.push(this.dropdownFieldAttribute);
            this.inputTypeFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('dropPlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.CheckboxField) {
            this.showCheckboxField = true;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showRadioField = false;
            this.showUrlField = false;
            this.showDateField = false;
            this.checkBoxFieldArray = [];
            this.checkBoxFieldAttribute = [];
            this.checkBoxFieldArray.push(this.checkBoxFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.imageTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.Image) {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = true;
            this.showCurrencyField = false;
            this.showNumberField = false;
            this.showRadioField = false;
            this.showUrlField = false;
            this.showDateField = false;
            this.imageTypeFieldArray = [];
            this.imageTypeFieldArray.push(this.imageTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.URL) {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = true;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showNumberField = false;
            this.showDateField = false;
            this.urlTypeFieldArray = [];
            this.urlTypeFieldArray.push(this.urlTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('urlPlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.Number || element.fieldTypeName ==this.constant.Address) {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = true;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showDateField = false;
            this.numberTypeFieldArray = [];
            this.numberTypeFieldArray.push(this.numberTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('numberPlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.Currency) {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = false;
            this.showCurrencyField = true;
            this.showRadioField = false;
            this.showDateField = false;
            this.numberTypeFieldArray = [];
            this.numberTypeFieldArray.push(this.numberTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('currencyPlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.Date) {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = false;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showDateField = true;
            this.dateTypeFieldArray = [];
            this.dateTypeFieldArray.push(this.dateTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('datePlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = false;
            this.showCurrencyField = false;
            this.showDateField = false;
            this.showRadioField = false;
            this.radioFieldArray.push(this.radioFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          }
        }
      });
    }
  }

  addNewField(value) {
    this.folderDetail = this.commonService.getEditData();
    this.fieldType = this.commonService.getFieldType();
    if (this.folderDetail != undefined) {
      this.folderId = this.folderDetail.folderID;
    }
    this.addFieldsVM.defaultValue = '';
    this.addFieldsVM.userID = this.currentUser.UID;
    this.addFieldsVM.databaseID = parseInt(sessionStorage.getItem('databaseId'));

    this.addFieldsVM.folderName = this.folderDetail.folderName;
    this.addFieldsVM.fieldTypeID = this.typeSelected;
    if (this.fieldType.subfolderId > 0) {
      this.addFieldsVM.fieldFolderType = this.fieldType.fieldType;
      this.addFieldsVM.folderID = this.fieldType.subfolderId;
    } else {
      this.addFieldsVM.fieldFolderType = 1;
      this.addFieldsVM.folderID = this.folderId;
    }
    let count = this.fieldListFolderWise.length;
    this.addFieldsVM.position = count + 1;
    this.fieldTypeList.forEach((element) => {
      if (element.fieldTypeID == this.typeSelected) {
        this.addFieldsVM.fieldTypeName = element.fieldTypeName;
      }
    });
    if (this.showDropdownBoxField == true) {
      this.dropdownFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.dropdownText + ',';
      });
    } else if (this.showCheckboxField == true) {
      this.checkBoxFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.Select + ',';
      });
    } else if (this.showTextBoxField == true) {
      this.inputTypeFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.fieldText;
        this.addFieldsVM.placeholder = element.placeholder;
      });
    } else if (this.showImageField == true) {
      this.imageTypeFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.altText;
      });
    } else if (this.showUrlField == true) {
      this.urlTypeFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.url;
      });
    } else if (this.showNumberField == true || this.showCurrencyField == true) {
      this.numberTypeFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.number;
      });
    } else if (this.showRadioField == true) {
      this.radioFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.radioText + ',';
      });
    }
    this.addFieldsVM.fieldName = this.fieldLabel;
    let lastIndex = this.addFieldsVM.defaultValue.length;
    this.addFieldsVM.defaultValue = this.addFieldsVM.defaultValue.substr(
      0,
      lastIndex - 1
    );
    this.addFieldsVM.organizationID=Number(sessionStorage.getItem('organizationID'));
    this.addFieldsVM.officeID=this.myOfficeID;
    this.addFieldsVM.OfficeIDList=this.OfficeIDList;
    this.settingsService.addField(this.addFieldsVM).subscribe((response) => {
      if (response != undefined) {
        this.addFieldResponseHolder = response;
        this.inputTypeFieldArray = [];
        this.checkBoxFieldArray = [];
        this.dropdownFieldArray = [];
        if (this.addFieldResponseHolder.status == this.statusConst.statusSuccess) {         
          this.toastr.success('Field added successfully.', '', {
            timeOut: 3000,
          });
          this.closecreateField(false);
          this.getAllFields();
        } else {
          this.toastr.error(this.addFieldResponseHolder.message, '', {
            timeOut: 3000,
          });
          this.closeSlide.emit(false);
        }
      }
    });
  }

  deleteField(value) {
    if (value == 'c') {
      let arrayLength = this.checkBoxFieldArray.length;
      this.checkBoxFieldArray.splice(arrayLength - 1, 1);
    } else if (value == 'd') {
      let arrayLength = this.dropdownFieldArray.length;
      this.dropdownFieldArray.splice(arrayLength - 1, 1);
    } else if (value == 'r') {
      let arrayLength = this.radioFieldArray.length;
      this.radioFieldArray.splice(arrayLength - 1, 1);
    }   
  }
}
